import stadium from "./media/icons/1.png"
import running_course from "./media/icons/2.png"
import swimming_pool from "./media/icons/3.png"
import gym from "./media/icons/4.png"
import athletic_gym from "./media/icons/5.png"
import open_ground from "./media/icons/6.png"
import football_field from "./media/icons/7.png"
import cycling_track from "./media/icons/8.png"
import training_gym from "./media/icons/9.png"
import arena from "./media/icons/10.png"
import indoor_ice from "./media/icons/11.png"
import outdoor_skating_course from "./media/icons/11.png"
import hockey_ground from "./media/icons/11.png"
import seasonal_skating from "./media/icons/11.png"
import skiing_complex from "./media/icons/12.png"
import biathlon_complex from "./media/icons/12.png"
import mountain_skiing_complex from "./media/icons/12.png"
import rowing_base from "./media/icons/13.png"
import yacht_club from "./media/icons/14.png"
import autotrack from "./media/icons/15.png"
import horse_base from "./media/icons/16.png"
import cordodrom from "./media/icons/17.png"
import extreme_sports_ground from "./media/icons/18.png"
import climbing_wall from "./media/icons/19.png"
import snowboard_park from "./media/icons/20.png"
import shooting_range from "./media/icons/21.png"
import shooting_stand from "./media/icons/21.png"
import shooting_range2 from "./media/icons/21.png"
import chess_club from "./media/icons/22.png"
import spot from "./media/icons/23.png"
import trampoline_complex from "./media/icons/24.png"
import bobslay_track from "./media/icons/25.png"
import bowling_center from "./media/icons/26.png"
import shadow from "./media/icons/shadow.png"
import photo from "./media/icons/icon_photo.png"
import empty from "./media/icons/empty.png"


const BUILDING_TYPE_ICONS = {
	"stadium": stadium,
	"running_course": running_course,
	"swimming_pool": swimming_pool,
	"gym": gym,
	"athletic_gym": athletic_gym,
	"open_ground": open_ground,
	"football_field": football_field,
	"cycling_track": cycling_track,
	"training_gym": training_gym,
	"arena": arena,
	"indoor_ice": indoor_ice,
	"outdoor_skating_course": outdoor_skating_course,
	"hockey_ground": hockey_ground,
	"seasonal_skating": seasonal_skating,
	"skiing_complex": skiing_complex,
	"biathlon_complex": biathlon_complex,
	"mountain_skiing_complex": mountain_skiing_complex,
	"rowing_base": rowing_base,
	"yacht_club": yacht_club,
	"autotrack": autotrack,
	"horse_base": horse_base,
	"cordodrom": cordodrom,
	"extreme_sports_ground": extreme_sports_ground,
	"climbing_wall": climbing_wall,
	"snowboard_park": snowboard_park,
	"shooting_range": shooting_range,
	"shooting_stand": shooting_stand,
	"shooting_range2": shooting_range2,
	"chess_club": chess_club,
	"spot": spot,
	"trampoline_complex": trampoline_complex,
	"bobslay_track": bobslay_track,
	"bowling_center": bowling_center,
	"shadow": shadow,
	"photo": photo,
	"empty": empty
}

export default BUILDING_TYPE_ICONS;


// WEBPACK FOOTER //
// ./src/icons.js